import React from "react";
import { Box, Typography } from "@mui/material";

/* Renders validation messages for a single template page.
 * This component is display-only: it receives prepared messages and shows them
 * with the warning styling used in the template modal.
 */
interface TemplateValidationMessagesProps {
  messages: string[];
  darkMode: boolean;
}

const TemplateValidationMessages: React.FC<TemplateValidationMessagesProps> = ({
  messages,
  darkMode,
}) => {
  if (!messages.length) return null;

  return (
    <Box
      sx={{
        mt: 1,
        px: 2,
        py: 1.5,
        borderRadius: "8px",
        bgcolor: darkMode ? "rgba(239,68,68,0.12)" : "rgba(239,68,68,0.08)",
        border: "1px solid rgba(239,68,68,0.35)",
        display: "flex",
        flexDirection: "column",
        gap: 0.5,
      }}
    >
      {messages.map((message, index) => (
        <Typography
          key={`${message}-${index}`}
          variant="caption"
          sx={{
            color: darkMode ? "#fca5a5" : "#dc2626",
            fontFamily: '"Lexend", sans-serif',
          }}
        >
          • {message}
        </Typography>
      ))}
    </Box>
  );
};

export default TemplateValidationMessages;
